module.exports = __webpack_public_path__ + "static/media/logoByVisiperf.623a02e4.svg";